<div class="field-dialog" *ngIf="groupForm">
  <mat-toolbar class="field-dialog__header" fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="field-dialog__header__title">
      {{ (group?.id ? 'GROUPS.EDIT_GROUP' : 'GROUPS.CREATE_GROUP') | translate }}
    </h2>

    <button class="field-dialog__header__close" mat-icon-button (click)="matDialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>

  <mat-tab-group class="field-dialog__content" [(selectedIndex)]="selectedTabIndex">
    <mat-tab label="{{ 'GROUPS.DIALOG.GENERAL' | translate }}">
      <disclaimer
        *ngIf="disabled || isViewMode"
        [message]="(isViewMode ? 'GROUPS.PERMISSIONS.NO_EDIT' : 'GROUPS.DIALOG.NO_EDIT') | translate"
      >
      </disclaimer>
      <tab-general [groupForm]="groupForm" [disabledOrViewMode]="disabled || isViewMode"></tab-general>
    </mat-tab>

    <mat-tab label="{{ 'GROUPS.DIALOG.USERS' | translate }}" [disabled]="!group.id">
      <disclaimer *ngIf="isViewMode" [message]="'GROUPS.PERMISSIONS.NO_EDIT' | translate"> </disclaimer>
      <tab-users [linkedUsers]="groupForm.get('users')" [isViewMode]="isViewMode" [groupId]="group.id"></tab-users>
    </mat-tab>

    <mat-tab
      label="{{ 'GROUPS.DIALOG.LOCATIONS' | translate }}"
      [disabled]="!group.id"
      *ngIf="hasLocationsPermissionsEnabled"
    >
      <ng-template matTabContent>
        <tab-locations [isViewMode]="isViewMode" [group]="group"></tab-locations>
      </ng-template>
    </mat-tab>

    <mat-tab label="{{ 'GROUPS.DIALOG.SEGMENTS' | translate }}" [disabled]="!group.id">
      <ng-template matTabContent>
        <tab-segments [isViewMode]="isViewMode" [group]="group"></tab-segments>
      </ng-template>
    </mat-tab>

    <mat-tab label="{{ 'GROUPS.DIALOG.TABS.PERMISSIONS.TITLE' | translate }}" [disabled]="!group.id">
      <ng-template matTabContent>
        <disclaimer *ngIf="isViewMode" [message]="'GROUPS.PERMISSIONS.NO_EDIT' | translate"> </disclaimer>
        <tab-permissions [isViewMode]="isViewMode" [categoriesArray]="groupForm.get('categories')"></tab-permissions>
      </ng-template>
    </mat-tab>
  </mat-tab-group>

  <div
    *ngIf="!isViewMode"
    class="field-dialog__footer"
    fxLayout="row"
    fxLayoutAlign="space-between center"
    fxLayoutGap="15px"
  >
    <ng-container>
      <button
        class="field-background"
        *ngIf="!group.id && selectedTabIndex === 0"
        mat-raised-button
        [disabled]="groupForm?.invalid"
        (click)="continue()"
      >
        {{ 'GROUPS.DIALOG.CONTINUE' | translate }}
      </button>

      <button
        class="field-background"
        mat-raised-button
        [disabled]="groupForm.invalid || isSaving"
        *ngIf="group.id"
        (click)="saveGroup({ closeDialog: true })"
      >
        {{ 'GROUPS.DIALOG.SAVE' | translate }}
      </button>
    </ng-container>

    <div *ngIf="group.id">
      <button
        mat-icon-button
        class="archive-icon"
        (click)="archiveOrUnarchiveUserGroup(group)"
        [disabled]="isLoading || groupForm.invalid || !hasEditGroupPermission || group.locked"
        [matTooltip]="group.archived ? ('GROUPS.DIALOG.UNARCHIVE' | translate) : ('GROUPS.DIALOG.ARCHIVE' | translate)"
      >
        <mat-icon>
          {{ group.archived ? 'unarchive' : 'archive' }}
        </mat-icon>
      </button>
    </div>
  </div>
</div>
